export const config = {
	apiBaseUrl: {
		development: 'http://localhost:8084/api',
		//development: 'http://api-staging.collegerecon.com/api',
		staging: 'https://api-staging.collegerecon.com/api',
		production: 'https://api.collegerecon.com/api'
	},
		legionUrl: {
		development: 'http://localhost:8186/',
		staging: 'http://legion-staging.collegerecon.com/',
		production: 'https://legion.collegerecon.com/'
	},
	serverUrl:{
		development: 'http://localhost:8186',
		//development: 'http://api-staging.collegerecon.com/api',
		staging: 'https://dev-app.collegerecon.com',
		production: 'https://app.collegerecon.com'
	},
	resourceUrl:{
		development: 'http://localhost:8084',
		//development: 'http://api-staging.collegerecon.com/api',
		staging: 'http://api-staging.collegerecon.com',
		production: 'https://api.collegerecon.com'
	}
};


// WEBPACK FOOTER //
// ./src/config.ts